// src/components/BlogPostPage.js

import React, { useMemo } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { parseMarkdown } from '../utils/markdownParser';
import SEO from './SEO';

// IMPORT the InfographicMagnifier component
import InfographicMagnifier from './InfographicMagnifier'; // <-- IMPORT the component


// --- Webpack's require.context to import all markdown files ---
const markdownContext = require.context('!!raw-loader!../blog-posts', false, /\.md$/);


const BlogPostPage = () => {
  const { slug } = useParams();

  const allPostsProcessed = useMemo(() => {
    const posts = {};
    const filePaths = markdownContext.keys();
    filePaths.forEach(filePath => {
      const rawContent = markdownContext(filePath).default;
      const { metadata, htmlContent } = parseMarkdown(rawContent);

      if (metadata && metadata.slug) {
        posts[metadata.slug] = {
          slug: metadata.slug,
          title: metadata.title || 'Untitled Post',
          date: new Date(metadata.date) || new Date(),
          author: metadata.author || '',
          description: metadata.description || '',
          htmlContent: htmlContent,
          infographicUrl: metadata.infographic_url || null,
          infographicAlt: metadata.infographic_alt || '',
        };
      } else {
        console.warn(`Skipping post ${filePath}: Missing slug in frontmatter.`);
      }
    });
    return posts;
  }, []);

  const post = allPostsProcessed[slug];

  if (!slug || !post) {
    console.warn(`Invalid or missing slug: ${slug}`);
    return <Navigate to="/404" replace />;
  }

  return (
    <div className="blog-post-container">
      <SEO
        title={`${post.title} - Jimatly Blog`}
        description={post.description}
        canonical={`https://www.jimatly.com/blog/${post.slug}`}
      />

      <article>
        <h1>{post.title}</h1>
        <p className="post-meta">
          {post.date.toLocaleDateString()}
          {post.author && ` by ${post.author}`}
        </p>

        {post.infographicUrl && (
          <InfographicMagnifier
            url={post.infographicUrl}
            alt={post.infographicAlt}
          />
        )}

        <div className="post-content">
          <div dangerouslySetInnerHTML={{ __html: post.htmlContent }} />
        </div>
      </article>
    </div>
  );
};

// Ensure your parseMarkdown utility in src/utils/markdownParser.js is the version that
// returns { metadata: data, htmlContent: htmlContent } using gray-matter and marked.


export default BlogPostPage;